import mapboxgl from 'mapbox-gl';
import mapbox_fov_marker from '../../assets/images/icons/mapbox_fov_marker.svg';

class FOVControlMarker extends mapboxgl.Marker {
  constructor(options?: mapboxgl.MarkerOptions) {
    const el = document.createElement('div');
    el.style.backgroundImage = `url('${mapbox_fov_marker}')`;
    el.style.backgroundSize = 'cover';
    el.style.width = '50px';
    el.style.height = '50px';
    el.style.cursor = 'all-scroll';

    super({...options, element: el});
  }
}

export default FOVControlMarker;
